const Help = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.003 21a8.8 8.8 0 0 1-3.51-.709 9.1 9.1 0 0 1-2.859-1.922 9.1 9.1 0 0 1-1.925-2.857A8.75 8.75 0 0 1 3 12.003q0-1.866.708-3.51a9.1 9.1 0 0 1 1.923-2.859 9.1 9.1 0 0 1 2.857-1.925A8.75 8.75 0 0 1 11.997 3q1.866 0 3.51.708a9.1 9.1 0 0 1 2.859 1.923 9.1 9.1 0 0 1 1.925 2.857A8.75 8.75 0 0 1 21 11.997a8.8 8.8 0 0 1-.709 3.51 9.1 9.1 0 0 1-1.922 2.859 9.1 9.1 0 0 1-2.857 1.925 8.75 8.75 0 0 1-3.509.709m5.672-3.325Q15.35 20 12 20t-5.675-2.325T4 12t2.325-5.675T12 4t5.675 2.325T20 12t-2.325 5.675"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12.062 7.739q.759 0 1.308.471.55.471.55 1.178 0 .55-.31.995a5 5 0 0 1-.714.819q-.513.465-.905 1.025-.39.56-.449 1.233-.02.196.123.327a.47.47 0 0 0 .33.132.47.47 0 0 0 .339-.135.6.6 0 0 0 .174-.317q.099-.506.402-.899.301-.393.662-.745.519-.515.921-1.124.403-.608.403-1.357a2.29 2.29 0 0 0-.836-1.818 2.92 2.92 0 0 0-1.96-.716q-.834 0-1.553.39-.718.39-1.149 1.08a.47.47 0 0 0-.063.343.39.39 0 0 0 .19.268q.198.105.4.05a.72.72 0 0 0 .356-.233q.333-.414.784-.69.45-.277.997-.277M12.439 16.285a.6.6 0 0 1-.439.177.6.6 0 0 1-.438-.177.6.6 0 0 1-.178-.439q0-.261.178-.438A.6.6 0 0 1 12 15.23q.261 0 .438.177a.6.6 0 0 1 .178.438q0 .262-.178.439"
    />
  </>
)
export default Help
